import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import AdminLayout from "../../components/layout/AdminLayout/AdminLayout";
import faqService from "../../services/faq/faqService";
import sweetAlert from "../../utils/sweetAlert";
import { toast } from "react-toastify";

export default function FaqList() {

    const [faqs, setFaqs] = useState([]);

    const [loading, setLoading] = useState(true);

    const [page, setPage] = useState(1);

    const [pageSize] = useState(10);

    const [search, setSearch] = useState("");

    const [totalPages, setTotalPages] = useState(0);


    useEffect(() => {

        loadFaqs();

    }, [page, search]);


    const loadFaqs = async () => {

        try {

            setLoading(true);

            const response = await faqService.getList(
                page,
                pageSize,
                search
            );

            if (response.success) {

                setFaqs(response.data.items);

                setTotalPages(response.data.totalPages);

            }

        }
        catch (error) {

            console.log(error);

            toast.error("Failed to load FAQs.");

        }
        finally {

            setLoading(false);

        }

    };


    const handleDelete = async (id) => {

        const confirmed = await sweetAlert.confirmDelete();

        if (!confirmed) {

            return;

        }

        try {

            const response = await faqService.delete(id);

            if (response.success) {

                toast.success(response.message);

                loadFaqs();

            }
            else {

                toast.error(response.message);

            }

        }
        catch (error) {

            console.log(error);

            toast.error("Something went wrong.");

        }

    };


    return (

        <AdminLayout>

            <div className="page-header">

                <h2>FAQs</h2>

                <Link
                    to="/faqs/add"
                    className="btn btn-primary"
                >
                    Add FAQ
                </Link>

            </div>


            {/* Search */}

            <div className="d-flex mb-3 gap-2">

                <input
                    type="text"
                    className="form-control"
                    placeholder="Search FAQ..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />

                <button
                    className="btn btn-primary"
                    disabled={loading}
                    onClick={() => setPage(1)}
                >
                    Search
                </button>

            </div>


            {/* Table */}

            <div className="card">

                <div className="card-body">

                    <table className="table table-bordered">

                        <thead>

                            <tr>

                                <th >
                                    Question
                                </th>

                                <th >
                                    Answer
                                </th>

                                <th>
                                    Display Order
                                </th>

                                <th>
                                    Status
                                </th>

                                <th>
                                    Action
                                </th>

                            </tr>

                        </thead>


                        <tbody>

                            {

                                loading ?

                                    <tr>

                                        <td
                                            colSpan="5"
                                            className="text-center"
                                        >
                                            Loading...
                                        </td>

                                    </tr>

                                    :

                                    faqs.length === 0 ?

                                        <tr>

                                            <td
                                                colSpan="5"
                                                className="text-center"
                                            >
                                                No FAQs Found
                                            </td>

                                        </tr>

                                        :

                                        faqs.map(item => (

                                            <tr
                                                key={item.faqId}
                                            >

                                                <td>
                                                    {item.question}
                                                </td>

                                                <td>
                                                    {item.answer}
                                                </td>

                                                <td>
                                                    {item.displayOrder}
                                                </td>

                                                <td>

                                                    {
                                                        item.isActive

                                                            ?

                                                            <span className="badge bg-success">
                                                                Active
                                                            </span>

                                                            :

                                                            <span className="badge bg-danger">
                                                                Inactive
                                                            </span>
                                                    }

                                                </td>

                                                <td>

                                                    <Link
                                                        to={`/faqs/edit/${item.faqId}`}
                                                        className="btn btn-warning btn-sm me-2"
                                                    >
                                                        Edit
                                                    </Link>


                                                    <button
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() =>
                                                            handleDelete(item.faqId)
                                                        }
                                                    >
                                                        Delete
                                                    </button>

                                                </td>

                                            </tr>

                                        ))

                            }

                        </tbody>

                    </table>

                </div>

            </div>


            {/* Pagination */}

            {
                totalPages > 1 &&

                <div className="d-flex justify-content-center mt-3 gap-2">

                    <button
                        className="btn btn-secondary"
                        disabled={page === 1}
                        onClick={() =>
                            setPage(page - 1)
                        }
                    >
                        Previous
                    </button>

                    <span className="align-self-center">
                        Page {page} of {totalPages}
                    </span>

                    <button
                        className="btn btn-secondary"
                        disabled={page === totalPages}
                        onClick={() =>
                            setPage(page + 1)
                        }
                    >
                        Next
                    </button>

                </div>

            }

        </AdminLayout>

    );

}